import { useMutation } from '@apollo/client/react';
import { ADD_PRODUCT_TO_CATALOG, GET_VENDOR_CATALOG } from 'api/graphql/catalog';
import { useVendor } from 'features/vendor';

/**
 * Adds a product to the vendor's catalog and refreshes the catalog list.
 *
 * Returns `addProduct(input)` which resolves to the mutation payload
 * (`{ success, message, errors, catalogItem }`) so the caller can surface
 * server-side field errors.
 */
export function useAddProduct() {
  const { vendorId } = useVendor();

  const [mutate, { loading }] = useMutation(ADD_PRODUCT_TO_CATALOG, {
    refetchQueries: vendorId
      ? [{ query: GET_VENDOR_CATALOG, variables: { vendorId } }]
      : [],
    awaitRefetchQueries: true,
  });

  const addProduct = async (input) => {
    // `vendorId` is part of VendorCatalogAddInput and comes from the session.
    const { data } = await mutate({ variables: { input: { ...input, vendorId } } });
    return data?.addProductToCatalog ?? null;
  };

  return { addProduct, loading };
}
